/* eslint-disable react/prop-types */
import CustomerTableStatic from "components/CustomerTableStatic";
import Footer from "components/Footer";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import MDBox from "components/MDBox";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import { setHomePage, useMaterialUIController } from "context";
import { useEffect, useMemo, useRef, useState } from "react";
import { useSetRecoilState } from "recoil";
import { AlertState } from "states";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import {
  ALLVALUE,
  API_ROUTES,
  ID_GROUP_CHUTHE,
  ID_GROUP_HOIDONG,
  ID_GROUP_NUMBER_SEVEN,
  ID_GROUP_PHUONGXA,
  ID_GROUP_NUMBER_ONE,
  ID_GROUP_CAPTINH,
  CODE_QUANGNAM,
} from "../../../utils/constants";
import dayjs from "dayjs";
import useAuth from "hooks/useAuth";
import { Grid } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import SelectCustomer from "components/SelectCustomer";

function ThongKeChuThe() {
  const [controller, dispatch] = useMaterialUIController();
  useEffect(() => {
    setHomePage(dispatch, false);
  }, []);
  const axiosPrivateInstance = useAxiosPrivate();
  const setAlert = useSetRecoilState(AlertState);
  const { user } = useAuth();
  const _timeOut = useRef();

  const [tableData, setTableData] = useState({});
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [cloneDataAll, setCloneDataALL] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowCount, setRowCount] = useState(0);
  const [optionDistrict, setOptionDistrict] = useState([]);
  const [optionSubDitrict, setOptionSubDitrict] = useState([]);
  const [paramsState, setParamsState] = useState({
    nam: null,
    maphuong: ALLVALUE.ma,
    maquan: ALLVALUE.ma,
  });

  useEffect(() => {
    const fetchDataQuanHuyen = async () => {
      try {
        let body = {
          tinh: CODE_QUANGNAM,
          huyen: isGroupNumberSeven ? user?.maquan : undefined,
        };
        const response = await axiosPrivateInstance.get(API_ROUTES.GETHUYEN, {
          params: body,
        });
        setOptionDistrict(response.data);
      } catch (error) {
        console.log(error);
        return;
      }
    };
    fetchDataQuanHuyen();
  }, []);

  //Kiểm tra nhóm người dùng với id Group
  const checkGroupUser = (user, idGroup) => {
    let check = false;
    if (user && user.id) {
      if (user?.group?.find((item) => item?.id == idGroup)) {
        check = true;
      }
    }
    return check;
  };
  //Kiểm tra nhóm người dùng là 1
  const isGroupNumberOne = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_NUMBER_ONE);
  }, [user]);
  //Kiểm tra nhóm người dùng là 9
  const isGroupNumberNine = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_CAPTINH);
  }, [user]);
  //kiểm tra nhóm người dùng là 5
  const isGroupOwner = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_CHUTHE);
  }, [user]);
  //kiểm tra nhóm người dùng là 7
  const isGroupNumberSeven = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_NUMBER_SEVEN);
  }, [user]);
  //kiểm tra nhóm người dùng là 8
  const isGroupPhuongXa = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_PHUONGXA);
  }, [user]);
  // Lấy toàn bộ dữ liệu
  const fetchData = async (
    { nam, maquan, maphuong },
    { pageIndex, pageSize },
    user
  ) => {
    if (!tableData?.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    try {
      const isOwner = checkGroupUser(user, ID_GROUP_CHUTHE);
      const isGroupSeven = checkGroupUser(user, ID_GROUP_NUMBER_SEVEN);
      const isGroupHoiDong = checkGroupUser(user, ID_GROUP_HOIDONG);
      let body = {
        maquan:
          isGroupSeven || isGroupHoiDong
            ? user?.maquan
            : maquan == ALLVALUE.ma
            ? undefined
            : maquan,
        username: isOwner ? user?.username : undefined,
        nam: nam && dayjs(nam)?.isValid() ? dayjs(nam)?.get("year") : undefined,
        maphuong: isGroupPhuongXa
          ? user.maphuong
          : maquan == ALLVALUE.ma
          ? undefined
          : maphuong,
        pageNumber: pageIndex + 1,
        countNumber: pageSize,
      };
      const response = await axiosPrivateInstance.get(API_ROUTES.QUANLYCHUTHE, {
        params: body,
      });
      const validatedData = validateObjectDuan(response.data.data);
      setTableData(validatedData);
      setRowCount(response?.data?.totalRecord);
    } catch (error) {
      setIsError(true);
      setAlert({
        alert: true,
        message: error?.message || "Lỗi!",
        type: "error",
      });
      console.log(error);
      return;
    }
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  };
  useEffect(() => {
    if (user && user.id) {
      _timeOut.current && clearTimeout(_timeOut.current);
      _timeOut.current = setTimeout(() => {
        fetchData(paramsState, pagination, user);
      }, [300]);
    }
  }, [pagination, user, paramsState]);

  useEffect(() => {
    const fetchDataCloneAll = async ({ nam, maquan, maphuong }, user) => {
      try {
        const isOwner = checkGroupUser(user, ID_GROUP_CHUTHE);
        const isGroupSeven = checkGroupUser(user, ID_GROUP_NUMBER_SEVEN);
        const isGroupHoiDong = checkGroupUser(user, ID_GROUP_HOIDONG);
        let body = {
          maquan:
            isGroupSeven || isGroupHoiDong
              ? user?.maquan
              : maquan == ALLVALUE.ma
              ? undefined
              : maquan,
          username: isOwner ? user?.username : undefined,
          nam:
            nam && dayjs(nam)?.isValid() ? dayjs(nam)?.get("year") : undefined,
          maphuong: isGroupPhuongXa
            ? user.maphuong
            : maquan == ALLVALUE.ma
            ? undefined
            : maphuong,
        };
        const response = await axiosPrivateInstance.get(
          API_ROUTES.QUANLYCHUTHE,
          { params: body }
        );
        const validatedData = validateObjectDuan(response.data.data);
        setCloneDataALL(validatedData);
      } catch (error) {
        setAlert({
          alert: true,
          message: error?.message || "Lỗi!",
          type: "error",
        });
        console.log(error);
        return;
      }
    };
    if (user && user.id) {
      fetchDataCloneAll(paramsState, user);
    }
  }, [paramsState, user]);

  const validateObjectDuan = (rawData) => {
    const dataFiltered = rawData?.map((item) => {
      let dataEachItem = { ...item };
      if (item?.ngaycap) {
        const value = item?.ngaycap;
        dataEachItem["ngaycap_format"] =
          value && dayjs(value).isValid()
            ? dayjs(value).format("DD/MM/YYYY")
            : value;
      }
      return { ...dataEachItem };
    });
    return dataFiltered;
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "id",
        enableEditing: false,
        enableHiding: false,
        enableColumnActions: false,
      },
      {
        accessorKey: "ten",
        header: "Tên chủ thể",
        size: 300,
      },
      {
        accessorKey: "diachi",
        header: "Địa chỉ",
        size: 250,
      },
      {
        accessorKey: "email",
        header: "Email",
        size: 100,
      },
      {
        accessorKey: "ngaycap_format",
        header: "Ngày cấp",
        size: 100,
      },
    ],
    []
  );

  //filter
  //nam
  const handleChangeDate = (value) => {
    setParamsState((prev) => {
      return {
        ...prev,
        nam: value,
      };
    });
  };
  const handleToClearDate = () => {
    setParamsState((prev) => ({
      ...prev,
      nam: null,
    }));
  };
  const getSubditrict = (code) => {
    axiosPrivateInstance
      .get(API_ROUTES.GETXA, { params: { huyen: code } })
      .then((res) => {
        setOptionSubDitrict(res?.data);
      })
      .catch(() => {});
  };
  //maquan
  const handleChangeDistrict = (e) => {
    let { value } = e.target;
    setParamsState((prev) => ({
      ...prev,
      maquan: value,
      maphuong: ALLVALUE.ma,
    }));
    getSubditrict(value);
  };
  const handleChangeState = (keyName) => (e) => {
    let { value } = e.target;
    setParamsState((prev) => ({
      ...prev,
      [keyName]: value,
    }));
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        pt={6}
        py={3}
        sx={{
          backgroundColor: "#fff",
          borderRadius: "0.5rem",
          px: 3,
        }}
      >
        <Grid
          container
          spacing={2}
          rowSpacing={2}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        >
          <Grid item xs={12} md={6} lg={4}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={paramsState?.nam ? dayjs(paramsState.nam) : null}
                views={["year"]}
                onChange={handleChangeDate}
                slotProps={{
                  textField: {
                    InputLabelProps: { shrink: true },
                    placeholder: "---Chọn năm---",
                    fullWidth: true,
                    inputProps: {
                      readOnly: true,
                    },
                  },
                  field: {
                    clearable: true,
                    onClear: handleToClearDate,
                  },
                }}
                label="Năm"
                sx={{
                  ".MuiInputLabel-shrink": {
                    fontSize: "0.875rem",
                    lineHeight: "1.6",
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
          {(isGroupNumberOne || isGroupNumberNine) && (
            <>
              <Grid item xs={12} md={4} lg={4}>
                <SelectCustomer
                  keyValue="maquan"
                  label="Quận huyện"
                  labelName="ten"
                  option={optionDistrict}
                  onChange={handleChangeDistrict}
                  state={paramsState.maquan}
                  unicode="ma"
                />
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <SelectCustomer
                  keyValue="maphuong"
                  label="Phường xã"
                  labelName="ten"
                  option={optionSubDitrict}
                  onChange={handleChangeState("maphuong")}
                  state={paramsState.maphuong}
                  unicode="ma"
                />
              </Grid>
            </>
          )}{" "}
        </Grid>
      </MDBox>
      <MDBox py={3}>
        <CustomerTableStatic
          count={rowCount}
          columns={columns}
          data={tableData}
          allData={cloneDataAll}
          isUsingAllData={true}
          isLoading={isLoading}
          isError={isError}
          setPagination={setPagination}
          pagination={pagination}
          isRefetching={isRefetching}
          tableHeaders={["Tên chủ thể", "Địa chỉ", "Email", "Ngày cấp"]}
          tableKeyValues={["ten", "diachi", "email", "ngaycap_format"]}
          filename={"ThongKeSanPhamOCOP"}
          titleTable={"Thống kê sản phẩm OCOP"}
          colWidths={[5, 35, 30, 20, 10]}
          widthPercentPDF={[35, 30, 20, 10]}
          orientaitionPage={"landscape"}
          dicSizeBreakWord={{
            email: 10,
          }}
        />
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ThongKeChuThe;
